<template>
  <aha-dropdown class="top-4">
    <aha-dropdown-items
      v-if="currentUser.rememberSettings"
      @hide="$emit('togglePresentOptions')"
      :visible="showPresentOptions"
      class="z-20 rounded-lg shadow w-72"
      right
    >
      <aha-dropdown-item
        class="present-now__wrapper"
        @click="$emit('handlePresentMenuClick', 'present-now')"
        v-if="!isNewPresentation"
      >
        <p class="mb-1 font-bold text-secondary-100">
          {{ $i18nPresenter.t('Present now') }}
        </p>
        <p class="text-xs text-base-80">
          {{ $i18nPresenter.t('Present from the current slide') }}
        </p>
      </aha-dropdown-item>
      <aha-dropdown-item
        class="present-now__wrapper"
        @click="$emit('handlePresentMenuClick', 'present-from-beginning')"
        v-if="!isNewPresentation"
      >
        <p class="mb-1 font-bold text-secondary-100">
          {{ $i18nPresenter.t('Present from beginning') }}
        </p>
        <p class="text-xs text-base-80">
          {{ $i18nPresenter.t('Present from the first slide') }}
        </p>
      </aha-dropdown-item>
      <aha-dropdown-item
        class="present-now__wrapper"
        @click="$emit('handlePresentMenuClick', 'present-with-backstage')"
        v-if="!isNewPresentation"
      >
        <p class="flex items-center mb-1 font-bold text-secondary-100">
          {{ $i18nPresenter.t('Present with Backstage') }}
          <aha-badge
            label="BETA"
            size="2xs"
            class="backstage__badge"
          />
        </p>
        <p class="text-xs text-base-80">
          {{ $i18nPresenter.t('View notes and control your presentation') }}
        </p>
      </aha-dropdown-item>
      <aha-input-group
        class="flex items-center pt-3 pb-3 pl-4 rounded-b-lg bg-secondary-10"
      >
        <aha-checkbox
          v-model="currentUser.rememberSettings.fullscreen"
          @change="toggleFullscreenSetting"
          id="full-screen-check"
        >
          {{ $i18nPresenter.t('Full screen') }}
        </aha-checkbox>
      </aha-input-group>
    </aha-dropdown-items>
  </aha-dropdown>
</template>

<script>
import { mapState } from 'vuex'
import utils from '@/util'
import eventCategories from '@/constant/eventCategories'
import UserApi from '@/api/user'

export default {
  props: {
    showPresentOptions: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState({
      isNewPresentation: (state) => state.isNewPresentation,
      presentation: (state) => state.presentation,
      currentUser: (state) => state.currentUser,
    }),
  },
  methods: {
    // AHA-890 Remember fullscreen setting
    toggleFullscreenSetting(e) {
      this.$nextTick(async () => {
        const payload = {
          fullscreen: e,
        }
        await UserApi.updateSettings(payload)

        if (e) {
          utils.mixpanelTracking(
            eventCategories.PRESENTATION_EDITOR,
            'Extra Present Button > Fullscreen checkbox > Checked fullscreen mode',
          )
        } else {
          utils.mixpanelTracking(
            eventCategories.PRESENTATION_EDITOR,
            'Extra Present Button > Fullscreen checkbox > Unchecked fullscreen mode',
          )
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.present-now__wrapper {
  @apply h-auto pt-4 pb-3 border-b rounded-t-lg border-base-30 px-4;
}
.backstage__badge {
  @apply bg-yellow-50 ml-1;
}
</style>
